<template>
  <div>
    <div
      class="bottom-navbar d-flex flex-row-reverse justify-content-around align-items-center"
    >
      <router-link
        v-slot="{ isExactActive, navigate }"
        to="/"
        @click.native="closeMenu"
      >
        <div
          class="menu-item d-flex flex-column justify-content-between align-items-center"
          :class="{ 'active-menu-item': isExactActive }"
          @click="navigate"
        >
          <span class="menu-item-icon">
            <home-icon :active="isExactActive" />
          </span>
          <span class="menu-item-label"> خانه </span>
        </div>
      </router-link>

      <router-link
        v-slot="{ navigate }"
        to="/account-summaries"
        @click.native="closeMenu"
      >
        <div
          class="menu-item d-flex flex-column justify-content-between align-items-center"
          :class="{ 'active-menu-item': isAccountSummariesActive }"
          @click="navigate"
        >
          <span class="menu-item-icon">
            <list-icon :active="isAccountSummariesActive" />
          </span>
          <span class="menu-item-label">
            صورتحساب
          </span>
        </div>
      </router-link>

      <router-link
        v-slot="{ navigate }"
        to="/account-details"
        @click.native="closeMenu"
      >
        <div
          class="menu-item d-flex flex-column justify-content-between align-items-center"
          :class="{ 'active-menu-item': isAccountDetailsActive }"
          @click="navigate"
        >
          <span class="menu-item-icon">
            <money-icon :active="isAccountDetailsActive" />
          </span>
          <span class="menu-item-label"> تراکنش  ها </span>
        </div>
      </router-link>
      <router-link
        v-slot="{ navigate }"
        to="/account-expenses"
        @click.native="closeMenu"
      >
        <div
          class="menu-item d-flex flex-column justify-content-between align-items-center"
          :class="{ 'active-menu-item': isAccountExpensesActive }"
          @click="navigate"
        >
          <span class="menu-item-icon">
            <book-icon :active="isAccountExpensesActive" />
          </span>
          <span class="menu-item-label"> هزینه‌ها </span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import BookIcon from './svg-icons/BookIcon.vue'
import HomeIcon from './svg-icons/HomeIcon.vue'
import ListIcon from './svg-icons/ListIcon.vue'
import MoneyIcon from './svg-icons/MoneyIcon.vue'

export default {
  components: {
    HomeIcon,
    ListIcon,
    MoneyIcon,
    BookIcon,
  },
  computed: {
    isAccountSummariesActive() {
      return this.$route.path === '/account-summaries'
    },
    isAccountDetailsActive() {
      return this.$route.path === '/account-details'
    },
    isAccountExpensesActive() {
      return this.$route.path === '/account-expenses'
    },
    // isDebtRegisterActive() {
    //     if (
    //         this.$route.path === "/debt-registration"
    //         || this.$route.path === "/debt-registration/list"
    //         || this.$route.path === "/debt-registration/current"
    //         || this.$route.path === "/debt-registration/current/store"
    //         || this.$route.path === "/debt-registration/civil"
    //         || this.$route.path === "/debt-registration/civil/store"
    //         || this.$route.path === "/debt-registration/other"
    //         || this.$route.path === "/debt-registration/other/store"
    //         || this.$route.path === "/bill-debt-registration"
    //         || this.$route.path === "/bill-debt-registration/registry"
    //
    //     ) {
    //         return true;
    //     }
    //     return false;
    // },
    // isReceiveDebtActive() {
    //     if (
    //         this.$route.path === "/receive-debt"
    //         || this.$route.path === "/receive-debt/registery"
    //         || this.$route.path === "/debtor"
    //
    //     ) {
    //         return true;
    //     }
    //     return false;
    // },
    // isCostPageActive() {
    //     if (
    //         this.$route.path === "/costs"
    //         || this.$route.path === "/cost/registry"
    //         || this.$route.path === "/cost/update"
    //
    //     ) {
    //         return true;
    //     }
    //     return false;
    // }
  },
  methods: {
    closeMenu() {
      this.$store.commit('app/CLOSE_MAIN_MENU_OPEN')
    },
  },
}
</script>

<style scoped>
.bottom-navbar {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 64px;
    width: 100%;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    background: #fff;
    z-index: 1010;
    /*box-shadow: 0 4px 18px 0 #d9d9d9;*/
    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
}

.menu-item {
    cursor: pointer;
    min-height: 48px;
}

.menu-item-label {
    font-size: 14px;
    font-weight: 400;
    color: #a5a5a5;
}

.active-menu-item {
    font-weight: 600;
    color: #7468f0;
}

.active-menu-item > * {
    font-weight: 600;
    color: #7468f0;
}
</style>
